import React, { useEffect, useMemo, useState } from "react";
import {useForm, useFieldArray } from'react-hook-form'
import classnames from "classnames";
import { Link, useNavigate } from "react-router-dom";
import Styles from "./styles.module.scss";
import { Icon } from '@iconify/react';
import Headline5 from "../../components/headings/Headline5";
import FromHead from "../../components/headings/FromHead";
import Fields from "../../components/field";
import DropDownListselect from "../../components/dropdown";
import Button from "../../components/button";
import * as CONSTANTS from "../../utils/CONSTANTS";
import PopupMenu from "../../components/popupmenu";
import RadioButton from '../../components/radio';
import EllowSubskills from '../../modal/subskill';
import CompanyModal from '../../modal/companyRating'
import StarRating from '../../components/rating'
import { REACT_APP_CANDIDATE, REACT_APP_CANDIDATE_FRELLANCER } from "../../utils/common";
import { postAPI, putAPI } from "../../api/api";
import { yupResolver } from "@hookform/resolvers/yup";
import RequestRating from "../../modal/requestRating";
import CheckHistory from "../../modal/checkHistory";
import { getHackerearthResult, getHistory, getJobDetails, getQuestions, requestCompanyRating, sendRatingReminder, sentSureveyLinkEmail } from "./services";
import NotificationAlert from "../../components/notification";
import mixpanelData from "../../utils/mixpanel";
import { checkLevel } from "../../utils/EllowUtils";


interface Props {
    // ClickHandler?: any;
    // allocatedTo?: any;
    // candidateId?: any;
    // profileMetadata?: any;
    // candidateStatus?: string | number;
    // allocationDefault?: any;
    // behalfof?: any;
    // sourcedBy?: string;
    // rejectReason?: any;
    ellowScreeningCertifications?: any
    companyRating?: any
    loginId?: any;
    candidateLoginId?: any;
    clickHandler?: any
    closeModal?: any
    assesmentLevel?: any;
    companyNames?: any;
    candidateName?: string;
    surveyAnswers?: any;
    surveySubmitted?: boolean;
    skillsList: any;
  }
  

const EllowAssessment: React.FC<Props> = ({
    ellowScreeningCertifications,
    companyRating,
    loginId,
    candidateLoginId,
    clickHandler,
    closeModal,
    assesmentLevel,
    companyNames,
    candidateName,
    surveyAnswers,
    surveySubmitted,
    skillsList
}) => {
    

    const[questions, setQuestions] = useState<any>()

    useEffect(() => {
      
        getRatingHistory()
        getSurveyQuestions()
    }, [])
    
    const getSurveyQuestions = () => {
        getQuestions().then((response => {
            if (response && response.status === 1) {
                setQuestions(response.data)
            }
        }))
   }

    const navigate = useNavigate()
    const [notification, setNotification] = useState<boolean>(false)
    const [message, setMessage] = useState<string>('')
    const [type, setType] = useState<string>('success')
    const [icon, setIcon] = useState<boolean>(false)
    const userLoginId = localStorage.getItem('loginId') || ''
    const [ requestRating, setRequestRating] = useState<boolean>()
    const [ShowHistory, setShowHistory] = useState<boolean>()
    const [jobDetails, setJobDetails] = useState<any>()
    const [historyData, setHistoryData] = useState<any>()
    const [subSkillModal, setSubskillsModal] = useState<boolean>()
    const [companyModal, setCompanyModal] = useState<boolean>()
    const [companyIndex, setCompanyIndex] = useState<number>(-1)
    const [companyAction, setCompanyAction] = useState<string>()
    const [skillIndex, setSkillIndex] = useState<number>(-1)
    const [skillAction, setSkillAction] = useState<string>()
    const [tab, setTab] = useState<string>('ratings')

    const [subskillsAssesment, setSubskillsAssesment] = useState
        <{ id: string, skills: any; skillRating: number; subSkills: { id: number, name: string } }[]>([])
    const [companyStarRating, setCompanyStartRating] = useState([])

    useEffect(() => {
        // const subskillsData: {id: string, skills: any; skillRating: number; subSkills: {id: number, name: string}}[]=[];
        if (ellowScreeningCertifications) {
            // ellowScreeningCertifications
            setSubskillsAssesment(ellowScreeningCertifications[0] && ellowScreeningCertifications[0].subSkills)
        }
        if (companyRating) {
            setCompanyStartRating(companyRating)
        }
    }, [companyRating])


    const getRatingHistory = () => {
        getHistory(loginId, userLoginId).then((response) => {
            if (response && response.status === 1) {
                setHistoryData(response.data)  
            }
        })
    }

    const onCloseSubskillModal = () => {
        setSubskillsModal(false)
        setCompanyModal(false)
    }

    const submitCompanyRating = (values: any) => {
        putAPI(REACT_APP_CANDIDATE_FRELLANCER + `/company-rating`, values).then((resp) => {
            if (resp.status === 1) {            
                mixpanelData('New TG - Company ratings updated', {
                    'Source': 'Recruiter deletes certifcations of a candidate',
                    'distinct_id': localStorage.getItem('Email'),
                    'Recruiter email': localStorage.getItem('Email'),
                    'Candidate name': resp.data[0].profile_metadata.firstName + ' ' + resp.data[0].profile_metadata.firstName,
                    'Candidate email': resp.data[0].profile_metadata.email,
                    'Candidate loginid': localStorage.getItem('ResourcesCandidateLoginId'),
                    'Company name': values.companyRatings.companyName,
                    'Designation': values.companyRatings.designation,
                    'Overall rating': values.companyRatings.overAllRating,
                    'Start date': new Date(values.companyRatings.startDate).toDateString(),
                    'End date': new Date(values.companyRatings.endDate).toDateString(),
                    'Productivity': values.companyRatings.subRatings.productivity,
                    'Communication': values.companyRatings.subRatings.communication,
                    'Code quality': values.companyRatings.subRatings.codeQuality
                  })
                onCloseSubskillModal()
                clickHandler();
            }
        })
    }

    const formOptions = {
        // resolver: yupResolver(),
    };

    const {
        register,
        handleSubmit,
        control,
        reset,
        watch,
        setValue,
        clearErrors,
        trigger,
        formState,
        // assesmentLevel,
    } = useForm(formOptions);

    const submitAssesment = (values: any) => {
        let data = {
            loginId: loginId,
            submittedBy: 'RECRUITER',
            userLoginId: localStorage.getItem('loginId'),
            profileMetadata: {
                assessmentLevel: values.assessmentLevel
            }
        }
        putAPI(REACT_APP_CANDIDATE + '/candidates' , data).then((resp) => {
            if (resp.status === 1) {
                mixpanelData('New TG - Resource level added', {
                    "distinct_id": localStorage.getItem('Email'),
                    "Recruiter email" : localStorage.getItem('Email'),
                    "Candidate email": resp && resp.data[0].profile_metadata.email,
                    "Candidate name": `${resp && resp.data[0].profile_metadata.firstName} ${resp && resp.data[0].profile_metadata.lastName}`,
                    "Level": values.assessmentLevel || values.assessmentLevel === 0 ?  checkLevel((values.assessmentLevel + 1))?.title : checkLevel((assesmentLevel + 1))?.title,
                    "Candidate loginid": loginId
                })
                onCloseSubskillModal()
                clickHandler();
            }
        })
    }

    const deleteSkillRating = (name: string, item: any) => {
        let values = {}
        switch (name) {
            case 'deleteSkill':
                values = {
                    loginId: loginId,
                    userLoginId: localStorage.getItem('loginId'),
                    profileMetadata: {
                        ellowScreeningCertifications: [{
                            certificationId: item.certificationId
                        }]
                    }
                }
                putAPI(REACT_APP_CANDIDATE_FRELLANCER + '/remove-certification', values).then((resp) => {
                    if (resp && resp.status === 1) {
                        mixpanelData('New TG - Certification details deleted', {
                            'Source': 'Recruiter deletes certifcations of a candidate',
                            'distinct_id': localStorage.getItem('Email'),
                            'Recruiter email': localStorage.getItem('Email'),
                            'Candidate name': resp.data[0].profile_metadata.firstName + ' ' + resp.data[0].profile_metadata.firstName,
                            'Candidate email': resp.data[0].profile_metadata.email,
                            'Candidate loginid': loginId,
                            'Certification skill': item.skills.name,
                            'Certification type': item.certificationType,
                            'Overall rating': item.overallRating,
                            'Subskills': item.subskills,
                            'Percentile': item.Percentile
                          })
                        onCloseSubskillModal()
                        clickHandler();
                    }
                })
                break;
            case 'clearRating':
                values = {
                    loginId: loginId,
                    userLoginId: localStorage.getItem('loginId'),
                    profileMetadata: {
                        ellowScreeningCertifications: [{
                            certificationId: item.certificationId,
                            certificationType: item.certificationType,
                            overallRating: item.overallRating,
                            notes: item.notes,
                            percentile: item.percentile,
                            skills: item.skills,
                            subSkills: []
                        }]
                    }
                }
                putAPI(REACT_APP_CANDIDATE_FRELLANCER + `/certification`, values).then((resp) => {
                    if (resp && resp.status === 1) {
                        onCloseSubskillModal()
                        clickHandler();
                    }
                })
        }
    }

    const deleteRating = (name: string, item: any) => {
        let values: any = {}

        switch (name) {
            case 'deleteCompany':
                values = {
                    action: 'delete',
                    section: 'companyRatings',
                    loginId: loginId,
                    userLoginId: localStorage.getItem('loginId'),
                    companyRatings: {
                        "companyRatingId": item.companyRatingId,
                        "companyId": item.companyId,
                        "companyName": item.companyName,
                        "designation": item.designation,
                        "overAllRating": item.overAllRating,
                        "disabled":false,
                        "startDate": item.startDate,
                        "endDate": item.endDate,
                        "subRatings": {
                            "productivity": item.subRatings && item.subRatings.productivity,
                            "leadership": 0,
                            "communication": item.subRatings && item.subRatings.communication,
                            "codeQuality": item.subRatings && item.subRatings.codeQuality,
                            "teamPlayer": 0
                        }
                    }
                }
                break;
            case 'disableCompany':
                values = {
                    action: 'update',
                    section: 'companyRatings',
                    loginId: loginId,
                    userLoginId: localStorage.getItem('loginId'),
                    companyRatings: {
                        "companyRatingId": item.companyRatingId,
                        "companyId": item.companyId,
                        "companyName": item.companyName,
                        "designation": item.designation,
                        "overAllRating": item.overAllRating,
                        "disabled": !item.disabled,
                        "startDate": item.startDate,
                        "endDate": item.endDate,
                        "subRatings": {
                            "productivity": item.subRatings && item.subRatings.productivity,
                            "leadership": 0,
                            "communication": item.subRatings && item.subRatings.communication,
                            "codeQuality": item.subRatings && item.subRatings.codeQuality,
                            "teamPlayer": 0
                        }
                    } 
                }
                break;
            default:
                values = {
                    action: 'update',
                    section: 'companyRatings',
                    loginId: loginId,
                    userLoginId: localStorage.getItem('loginId'),
                    companyRatings: {
                        companyId: item.companyId,
                        "companyRatingId": item.companyRatingId,
                        companyName: item.companyName,
                        designation: item.designation,
                        overAllRating: 0,
                        "disabled":false,
                        startDate: item.startDate,
                        endDate: item.endDate,
                        subRatings: {
                            productivity: 0,
                            leadership: 0,
                            communication: 0,
                            codeQuality: 0,
                            teamPlayer: 0
                        }
                    }
                }
                break;
                       
        }

        
        putAPI(REACT_APP_CANDIDATE_FRELLANCER + `/company-ratings`, values).then((resp) => {
            if (resp.status === 1) {
                mixpanelData('New TG - Ratings deleted', {
                    'Source': 'Recruiter deletes ratings of a candidate',
                    'distinct_id': localStorage.getItem('Email'),
                    'Recruiter email': localStorage.getItem('Email'),
                    'Candidate name': resp.data[0].profile_metadata.firstName + ' ' + resp.data[0].profile_metadata.firstName,
                    'Candidate email': resp.data[0].profile_metadata.email,
                    'Candidate loginid': localStorage.getItem('ResourcesCandidateLoginId'),
                    'Company name': values.companyRatings.companyName,
                    'Designation': values.companyRatings.designation,
                    'Overall rating': values.companyRatings.overAllRating,
                    'Start date': new Date(values.companyRatings.startDate).toDateString(),
                    'End date': new Date(values.companyRatings.endDate).toDateString(),
                    'Productivity': values.companyRatings.subRatings.productivity,
                    'Communication': values.companyRatings.subRatings.communication,
                    'Code quality': values.companyRatings.subRatings.codeQuality
                  })
                onCloseSubskillModal()
                clickHandler();
            }
        })
    }

    const hackerEarthRedirection = (url : string) => {
        if(url !== ' ' && url !== undefined)
        {
            window.location.href = url
        }
    }

    const submitSubskills = () => {
        onCloseSubskillModal()
        clickHandler();
    }
    

    const fetchJobDetails = (data: any) => {
        getJobDetails(data.jobId, loginId).then((response) => {
            if (response && response.status === 1) {
                let jobData = {
                    email: response.data[0].companyemail,
                    designation: response.data[0].designation,
                    contractDuration: {
                        end: new Date(parseInt(response.data[0].enddate)),
                        start: new Date(parseInt(response.data[0].startdate))
                    } 
                    }
                setJobDetails(jobData)
           }
        })
    }

    const requestCompany = (data: any) => {

        let value = {   
                "loginId":loginId,
                "userLoginId": localStorage.getItem('loginId'),
                "customerId": data.companyName && data.companyName.companyId,
                "companyName": data.companyName && data.companyName.companyName,
                "designation": data.designation,
                "candidateName": candidateName,
                "contractStartDate": data.contractDuration && data.contractDuration.from && data.contractDuration.from.toString(),
                "contractEndDate":  data.contractDuration && data.contractDuration.to && data.contractDuration.to.toString(),
                "email": data.email,
                "emailBody": data.emailBody,
                "submittedBy":"RECRUITER"           
        }
        requestCompanyRating(value).then((response) => {
            if (response && response.status === 1) {
                mixpanelData('New TG - Company rating requested', {
                    'distinct_id': localStorage.getItem('Email'),
                    'Recruiter email': localStorage.getItem('Email'),
                    'Candidate loginid': candidateLoginId,
                    'Candidate name': candidateName,
                    'Company name': data.companyName && data.companyName.companyName,
                    'Designation': data.designation,
                    'Start date': data.contractDuration && data.contractDuration.from && new Date(data.contractDuration.from).toDateString(),
                    'End date': data.contractDuration && data.contractDuration.to && new Date(data.contractDuration.to).toDateString(),
                    'Employer email': data.email
                })
                setRequestRating(false)
                setType('success')
                setIcon(true)
                displayNotification('Company rating requested successfully')
                getRatingHistory()
        
            }
            if (response && response.status === '2') {
                setRequestRating(false)
                displayNotification('Company rating already requested')
                setType('error') 
                setIcon(false)
            }
        })
    }

    const sendReminder = (requestId: string) => {

        let body = {          
                "requestId": requestId,
                "submittedBy":"RECRUITER"          
        }
        sendRatingReminder(body).then((response) => {
            if (response && response.status === 1) {
                getRatingHistory()
            }
        })
    }

    const displayNotification = (message: string) => {
        setMessage(message)
        setNotification(true)
        setTimeout(() => {
           setNotification(false)
         }, 3000);
    }
    
    const sentSurveyEmail = () => {
        let body = {
            "loginId": loginId
        }
        sentSureveyLinkEmail(body).then((response) => {
            if (response && response.status === 1) {
                mixpanelData('TG- Survey link shared', {
                    'source': 'Recruiter sent survey mail to candidate',
                    'distint_id': localStorage.getItem('Email'),
                    'Candidate Name': response.data && response.data[0] && response.data[0].name,
                    'candidate Email': response.data && response.data[0] && response.data[0].email,
                    'Recruiter Email': localStorage.getItem('Email')
                })
                mixpanelData('New TG - Survey requested', {
                    'source': 'Recruiter requested survey to candidate',
                    'distinct_id': localStorage.getItem('Email'),
                    'Candidate name': response.data && response.data[0] && response.data[0].name,
                    'candidate email': response.data && response.data[0] && response.data[0].email,
                    'Recruiter email': localStorage.getItem('Email'),
                    'Candidate loginid': loginId
                })
                setType('success')
                setIcon(true)
                displayNotification("Email with survey link shared successfully")                
            }
        })
    }
    
    const checkSurveyAnswers = (ans: any) => {
        if (ans && typeof (ans) === 'object') {
           let newAns =  ans.map((item: any, key: number) => {
             return item + (key + 1 < ans.length ? ", " : '')
           })
           return newAns
        }
        else {
            return ans
        }
       
    }
    
    const downloadHandle=(url:any, skillName: string)=>{     
         
        fetch(url).then((response: any) => {
            
          response.blob().then((blob: any) => {
              const fileURL = window.URL.createObjectURL(blob);
              let alink = document.createElement('a');
              alink.href = fileURL;
              alink.download =`${candidateName}-${skillName}-result.pdf`;
              alink.click();
          })
      })
      }

    const downloadResult = (skillId: number, url: string, skillName: string) => {
        getHackerearthResult(loginId, skillId, url).then((response) => {
            if (response && response.status === 1) {
                downloadHandle(response.data[0], skillName)
        }         
     })
    }

    return (
        <>
            <div className={Styles.tabPadding}>
                {subSkillModal && <EllowSubskills loginId={loginId} onClose={() => onCloseSubskillModal()} clickHandler={submitSubskills} action={skillAction} defaultValues={skillIndex !== -1 && ellowScreeningCertifications[skillIndex]} skillsList={skillsList} />}
                <Headline5>Ellow Assessment</Headline5>

                <div className={Styles.buttonTab}>
                    <button onClick={() => setTab('ratings')} className={tab === 'ratings' ? Styles.active : ''}>Ratings</button>
                    <button onClick={() => setTab('questionaire')} className={tab === 'questionaire' ? Styles.active : ''} >Questionnaire</button>
                </div>
                {tab === 'questionaire' && <div className={Styles.questionnaire}>
                    <div className={Styles.questionnaireInfo}>
                        {!surveySubmitted &&
                            <div>                          
                        <p>
                        This is a career survey, You can either fill manually while discussing with the candidate or trigger a link to the candidate via mail that they can use the link to submit the survey.
                        </p>
                         <div className={Styles.infoAction}>
                            <Button onClick={sentSurveyEmail} variant="secondary">Send Survey Link</Button>
                            <Button onClick={() => navigate('/survey')} variant="primary">Answer Now</Button>
                        </div>
                        </div>}
                    </div>
                   { surveySubmitted && <ol className={Styles.questionnaireList}>
                        {questions && questions.map((item: any, key: number) => {
                            return (
                                <li>
                                <h5>{item.question}{" "}</h5>
                                    <p><span>Ans:</span>{surveyAnswers && surveyAnswers[key + 1] && surveyAnswers[key + 1].map((ans: any) => { return (checkSurveyAnswers(ans))})}</p>
                            </li>
                            )
                        })
                           }
                    </ol>}
                </div>
                }
                {tab === 'ratings' &&
                    <div className={Styles.certificationDetails}>
                        <button className={Styles.addWorkHistory} onClick={() => { setSubskillsModal(true); setSkillIndex(-1) }}><Icon icon="fluent:add-circle-20-regular" />Certification</button>
                        <div className={Styles.certificationCardWrap}>
                            {ellowScreeningCertifications && ellowScreeningCertifications.map((item: any, key: number) => {
                                return (
                                    <div className={Styles.certificationCard} key={key} >
                                        <div className="half-form-wrap" >
                                            <div className="form-group">
                                                <label className="lablel">Skill</label>
                                                <Fields defaultValue={item.skills && item.skills.name} disabled={true} />
                                            </div>
                                            <div className="form-group">
                                                <label className="lablel">Certified via</label>
                                                <Fields defaultValue={item.certificationType} placeholder='' disabled={true} />
                                            </div>
                                        </div>
                                        <div className={Styles.subHead}>Overall ratings <span className={Styles.total}><StarRating value={item.overallRating && item.overallRating} disabled={true} /></span><span className={Styles.total}>{item.percentile  ? item.percentile === 0 ? 0 : item.percentile + '%' : ''}</span></div>
                                        <Button onClick={() => downloadResult((item.skill && item.skill.skillId), (item.hackerEarthReportUrl), (item.skill && item.skill.skillName))} variant="secondary">View Details</Button> 
                                        {item.subSkills && item.subSkills.length > 0 ? item.subSkills.map((subskill: any, subkey: number) => {
                                            return (
                                                <div className={Styles.skillsRating} key={subkey}>{subskill.subSkillName ? subskill.subSkillName : subskill.subSkills.name} <span><StarRating value={subskill.skillRating} disabled={true} /></span></div>
                                            )
                                        }) : <div className={Styles.info}>Please give your ratings as soon you selected your skills</div>}
                                        {item.subSkills && item.subSkills.length > 0 ? <div className={Styles.cardAction}>
                                            <div></div>
                                            <PopupMenu>
                                                <div className={Styles.popupLinks}>
                                                    <Link to="" onClick={() => { setSubskillsModal(true); setSkillIndex(key) }}><Icon icon="lucide:edit-2" />Edit</Link>
                                                    <Link to="" onClick={() => deleteSkillRating('clearRating', item)}><Icon icon="ant-design:star-outlined" />Clear Ratings</Link>
                                                    <Link to="" onClick={() => deleteSkillRating('deleteSkill', item)}><Icon icon="material-symbols:delete-outline-rounded" />Delete</Link>
                                                </div>
                                            </PopupMenu>
                                        </div> : <div className={Styles.cardAction}>
                                            <div className={Styles.action}>
                                                {/* <Button onClick={[]} variant="secondary">
                                        <span className={Styles.ratingIcon}>
                                        <Icon icon="ant-design:star-outlined" />
                                        </span>Give Ratings</Button>  */}
                                                {/* <Button onClick={[]} variant="primary">Save</Button>  */}
                                            </div>
                                            <PopupMenu>
                                                <div className={Styles.popupLinks}>
                                                    <Link to="" onClick={() => { setSubskillsModal(true); setSkillIndex(key) }}><Icon icon="lucide:edit-2" />Edit</Link>
                                                    <Link to="" onClick={() => deleteRating('clearRating', item)}><Icon icon="ant-design:star-outlined" />Clear Ratings</Link>
                                                    <Link to="" onClick={() => deleteSkillRating('deleteSkill', item)}><Icon icon="material-symbols:delete-outline-rounded" />Delete</Link>
                                                </div>
                                            </PopupMenu>
                                        </div>}
                                    </div>
                                )
                                                    
                            })}
                        </div>
                        <FromHead>Level </FromHead>
                        <form>
                            <div className="mb-40">
                                <div className={classnames("form-group", Styles.levalOptions)}>
                                    <RadioButton name="availabilityId" label="Level 1 Developer" value={0} handleChange={(e: any) => setValue('assessmentLevel', e.value)} defaultChecked={assesmentLevel === 0} />
                                    <p>A person with coding and unit testing experience</p>
                                </div>
                                <div className={classnames("form-group", Styles.levalOptions)}>
                                    <RadioButton name="availabilityId" label="Level 2 Developer" value={1} handleChange={(e: any) => setValue('assessmentLevel', e.value)} defaultChecked={assesmentLevel === 1} />
                                    <p>A person with experience in designing along with coding and testing and can perform code reviews with ease.</p>
                                </div>
                                <div className={classnames("form-group", Styles.levalOptions)}>
                                    <RadioButton name="availabilityId" label="Level 3 Developer" value={2} handleChange={(e: any) => setValue('assessmentLevel', e.value)} defaultChecked={assesmentLevel === 2} />
                                    <p>A person experienced in Designing, code reviewing, and mentoring junior developers</p>
                                </div>
                                <div className={classnames("form-group", Styles.levalOptions)}>
                                    <RadioButton name="availabilityId" label="Level 4 Developer" value={3} handleChange={(e: any) => setValue('assessmentLevel', e.value)} defaultChecked={assesmentLevel === 3} />
                                    <p>A person experienced in Managing the team and assigning tasks along with excellent designing and coding skills.</p>
                                </div>
                            </div>
                        </form>

                        {/* onClick={() => { { setCompanyModal(true); setCompanyIndex(-1); setCompanyAction('add') } }} */}

                        <div className={Styles.addWorkHistory}>
                            {/* <button className={Styles.addWorkHistory}><Icon icon="fluent:add-circle-20-regular" />Company Rating </button> */}
                            <PopupMenu title="Company Rating" icon="ic:baseline-arrow-drop-down" popupAlign="right">
                                <div className={Styles.popupLinks}>
                                    <Link to="" onClick={() => { { setCompanyModal(true); setCompanyIndex(-1); setCompanyAction('add') } }} ><Icon icon="mingcute:user-add-line" />Add manually</Link>
                                    <Link to="" onClick={() => { setRequestRating(true); setJobDetails('') }}><Icon icon="cil:building" />Request to company</Link>
                                </div>
                            </PopupMenu>
                            <Link to="" onClick={() => setShowHistory(true)} className={Styles.historyBtn}>Check History</Link>
                        </div>
                        {ShowHistory && <CheckHistory onClose={() => setShowHistory(false)} data={historyData} sendReminder={sendReminder} />}
                        {requestRating && <RequestRating onClose={() => setRequestRating(false)} clickHandler={requestCompany} companyNames={companyNames} fetchJobDetails={fetchJobDetails} defaultValues={jobDetails} />}
                        {companyModal && <CompanyModal companyRating={companyRating} onClose={() => setCompanyModal(false)} loginId={loginId} candidateLoginId={candidateLoginId} clickHandler={submitCompanyRating} action={companyAction} defaultValues={companyIndex !== -1 && companyRating[companyIndex]} />}
                        <div className={Styles.certificationCardWrap}>             
                                {companyStarRating && companyStarRating.map((item: any, key: any) => {
                                    return (
                                        <div className={Styles.certificationCard}>
                                            <div className={Styles.certificationCardHead}>
                                                <div className={Styles.headInfo}>
                                                    <h5>{item.companyName}</h5>
                                                    <p>{item.designation} {item.startDate && item.endDate && new Date(parseInt(item.startDate)).toDateString().slice(3) + '-'}  {item.startDate && item.endDate && new Date(parseInt(item.endDate)).toDateString().slice(3)}</p>
                                                </div>
                                                <PopupMenu>
                                                    <div className={Styles.popupLinks}>
                                                        {!item.disabled && <Link to="" onClick={() => { setCompanyModal(true); setCompanyIndex(key); setCompanyAction('update') }} ><Icon icon="lucide:edit-2" />Edit</Link>}
                                                        {!item.disabled && <Link to="" onClick={() => deleteRating('clearRating', item)}><Icon icon="ant-design:star-outlined" />Clear Ratings</Link>}
                                                        <Link to="" onClick={() => deleteRating('disableCompany', item)}><Icon icon={item.disabled ? 'tabler:user-check' : "tabler:user-off"} />{item.disabled ? 'Enable' : "Disable"}</Link>
                                                        <Link to="" onClick={() => deleteRating('deleteCompany', item)}><Icon icon="material-symbols:delete-outline-rounded" />Delete</Link>
                                                    </div>
                                                </PopupMenu>
                                            </div>
                                            <p>
                                                {item.comment}
                                            </p>
                                            <div className={Styles.subHead} id={key}>Overall ratings<span><StarRating disabled={true} defaultValue={item.overAllRating} /></span></div>
                                            <div>
                                                {item.subRatings && item.subRatings.codeQuality && <div className={Styles.skillsRating}><label>Code quaility</label><span><StarRating value={item.subRatings && item.subRatings.codeQuality} disabled={true} /></span></div>}
                                                {item.subRatings.productivity && <div className={Styles.skillsRating}><label>Productivity</label><span><StarRating value={item.subRatings.productivity} disabled={true} /></span></div>}
                                                {item.subRatings.communication && <div className={Styles.skillsRating}><label>Communication</label><span><StarRating value={item.subRatings.communication} disabled={true} /></span></div>}
                                                {item.subRatings.leadership && <div className={Styles.skillsRating}><label>Ability to drive projects to success with minimal guidance</label><span><StarRating value={item.subRatings.leadership} disabled={true} /></span></div>}
                                                {item.subRatings.teamPlayer && <div className={Styles.skillsRating}><label>Team player</label><span><StarRating value={item.subRatings.teamPlayer} disabled={true} /></span></div>}
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>
                        </div>       
                }   
                        {tab === 'ratings' && <Button onClick={handleSubmit(submitAssesment)} variant="primary">Save</Button>}
            </div>
            {notification && <NotificationAlert onClose={() => setNotification(false)} closable={true} type={type} icon={icon} >
                            {message}
                        </NotificationAlert>}
        </> 
    )
}
export default EllowAssessment;